import { DEFAULT_WHITE, MAIN_WHITE } from "../constants/colors";
import { AR, EN, RU, UA } from "../constants/local";
export const RECAPTCHA_SITE_KEY = "6LeRzOAqAAAAAJMJlDuM_0CnmxIibz0It0LfO0Ai";
export const stokeHandler = (hovered: boolean, selected: boolean): string => {
  if (selected) {
    return DEFAULT_WHITE;
  }
  if (hovered) {
    return MAIN_WHITE;
  }

  return "";
};

export const timeFormat = (duration: any) => {
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;

  let ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
};

export const debounce = (func: any, delay: number) => {
  let timeoutId: any;
  return function (...args: any[]) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
export function truncateString(input: string, max: number): string {
  if (input.length > max) {
    return input.substring(0, max) + "...";
  } else {
    return input;
  }
}

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {})
    .catch((err) => {
      console.error("Ошибка при копировании текста: ", err);
    });
};

export const languageHandler = (lng: string) => {
  if (lng === "en" || lng === "fr" || lng === "es") {
    return EN;
  }
  if (lng === "ru") {
    return RU;
  }
  if (lng === "ar") {
    return AR;
  }
  if (lng === "uk") {
    return UA;
  }
};

export const isIosSafari = () => {
  if (typeof window === "undefined") return false;

  const { maxTouchPoints, userAgent } = window.navigator;
  const isIosDevice = /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes("Macintosh") && maxTouchPoints > 1);
  const isWebkit = userAgent.includes("WebKit");
  const isOtherIosBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(userAgent);

  return isIosDevice && isWebkit && !isOtherIosBrowser;
};

export const movieTitleHandler = (lng: string, item: any) => {
  if (lng === "en") {
    return item.title;
  }
  if (lng === "ar") {
    return item?.title_ar;
  }
  if (lng === "ru") {
    return item?.title_ru;
  }
  if (lng === "uk") {
    return item?.title_ua;
  }

  return item?.title;
};

export const posterPathHandler = (lng: string, item: any) => {
  const localized =
    lng === "en"
      ? item?.backdrop_path_en
      : lng === "ar"
        ? item?.poster_path_ar
        : lng === "ru"
          ? item?.poster_path_ru
          : lng === "uk"
            ? item?.poster_path_ua
            : null;

  return (
    localized ||
    item?.poster_path ||
    item?.backdrop_path ||
    item?.backdrop_path_en ||
    item?.poster_path_ru ||
    item?.poster_path_ua ||
    item?.poster_path_ar ||
    null
  );
};

export function formatDateToDMY(isoDateStr: string) {
  const date = new Date(isoDateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Месяцы от 0 до 11
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function shuffleMoviesWithFixedCommercials(movies: any) {
  // Разделяем массив на два массива: с commercial_url и без него
  const moviesWithCommercial: any = [];
  const moviesWithoutCommercial: any = [];

  movies.forEach((movie: any, index: any) => {
    if (movie.commercial_url) {
      moviesWithCommercial.push({ movie, index }); // Сохраняем изначальный индекс
    } else {
      moviesWithoutCommercial.push(movie);
    }
  });

  // Перемешиваем только фильмы без commercial_url
  const shuffledMoviesWithoutCommercial = moviesWithoutCommercial
    .map((movie: any) => ({ movie, sort: Math.random() }))
    .sort((a: any, b: any) => a.sort - b.sort)
    .map(({ movie }: { movie: any }) => movie);

  // Восстанавливаем изначальный порядок элементов с commercial_url
  const result = [];
  let nonCommercialIndex = 0;

  for (let i = 0; i < movies.length; i++) {
    const commercial = moviesWithCommercial.find((c: any) => c.index === i);
    if (commercial) {
      result.push(commercial.movie); // Оставляем commercial_url на месте
    } else {
      result.push(shuffledMoviesWithoutCommercial[nonCommercialIndex]); // Берем перемешанные фильмы
      nonCommercialIndex++;
    }
  }

  return result;
}
